import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import theme from '../LayoutComponents/theme';
import LoadingCircle from './LoadingCircle';

export default function PostRegistrationCard({ loading }) {
  return (
    <Card
      sx={{
        maxWidth: 600,
        mx: 'auto',
        mt: 4,
        borderRadius: 3,
        boxShadow: 4,
        p: 3,
        textAlign: 'center',
      }}
    >
      <CardContent>
        {/* Title */}
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ color: theme.colors.yellow, mb: 2 }} // bright yellow
        >
          Welcome to the National Talent Hub™
        </Typography>

        {/* Subtitle with colored keyword */}
        <Typography variant="body1" sx={{ mb: 2 }}>
          You’re now part of the{' '}
          <Box component="span" sx={{ color: theme.colors.purple, fontWeight: theme.typography.fontWeightBold }}>
            National Apprenticeship Network
          </Box>
          — a nationwide community connecting talent, training, and opportunity.
          Please verify your email address by clicking the link sent to your email.
        </Typography>

        {/* Instruction text */}
        <Typography variant="body2" sx={{ mb: 4 }}>
          Once verified, you’ll build your profile to see how your skills align with real career and
          apprenticeship pathways, explore training options, and connect directly with job
          opportunities. 
        </Typography>

        {/* Loading spinner */}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <LoadingCircle/>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
